import { render, staticRenderFns } from "./AddRemittance.vue?vue&type=template&id=7739bef6&"
import script from "./AddRemittance.vue?vue&type=script&lang=js&"
export * from "./AddRemittance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports